module.exports = __webpack_public_path__ + "images/feature/141110_zoom_1-dbb571e9a1f0d833f0e06fdc4e962a82.png";